import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { AppStateProvider } from './app/AppState';
import { RouterProvider } from './app/router';
import { AnnouncerProvider } from './components/Status';
import { LanguageProvider } from './i18n';
import { getRepositories, ReposContext } from './repositories';
import { blockPageZoom } from './lib/pageZoom';
import { AssistantProvider } from './assistant/AssistantState';

import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/shell.css';
import './features/tree/tree.css';
import './features/stories/stories.css';
import './features/recipes/recipes.css';
import './features/passedDown/passedDown.css';
import './features/auth/auth.css';
import './features/admin/admin.css';
import './assistant/assistant.css';

// The page itself never scales; the things that zoom do it themselves (see lib/pageZoom.ts).
blockPageZoom();

const repos = getRepositories();

// Until the backend lands, the family's photos and stories live only in this browser's
// storage. Ask the browser to treat it as persistent so it is not evicted under storage
// pressure. Best effort: some browsers say no, none throw.
try {
  void navigator.storage?.persist?.();
} catch {
  /* ignore */
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ReposContext.Provider value={repos}>
      <LanguageProvider>
        <AnnouncerProvider>
          <RouterProvider>
            <AppStateProvider>
              {/* Inside AppState and the router: the assistant reads where you
                  are and what you are allowed to do, and acts through the same
                  doors a person's finger does. */}
              <AssistantProvider>
                <App />
              </AssistantProvider>
            </AppStateProvider>
          </RouterProvider>
        </AnnouncerProvider>
      </LanguageProvider>
    </ReposContext.Provider>
  </StrictMode>,
);
